import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './horizontal-scroll-with-mask.scss';

const BASE_CLASS = 'horizontal-scroll-with-mask';

const HorizontalScrollWithMask = ({
    children,
}) => {
    const wrapperRef = useRef();
    const firstElRef = useRef();
    const lastElRef = useRef();
    const [maskClasses, setMaskClasses] = useState({ left: false, right: false });
    const classes = classNames(
        BASE_CLASS,
        {
            [`${BASE_CLASS}--left`]: maskClasses.left,
            [`${BASE_CLASS}--right`]: maskClasses.right,
        }
    );

    const handleObserver = entries => {
        entries.forEach(({
            target,
            isIntersecting,
        }) => {
            const maskClass = target === firstElRef.current ? 'left' : 'right';
            setMaskClasses(prevState => ({...prevState, [maskClass]: !isIntersecting }));
        });
    };

    useEffect(() => {
        const observerOptions = { root: wrapperRef.current };
        const observer = new IntersectionObserver(handleObserver, observerOptions);
        observer.observe(firstElRef.current);
        observer.observe(lastElRef.current);

        return () => observer.disconnect();
    }, [
        wrapperRef.current,
        firstElRef.current,
        lastElRef.current,
    ]);

    return (
        <div className={classes} ref={wrapperRef}>
            <div className={`${BASE_CLASS}__scroll-container`}>
                <div ref={firstElRef}></div>
                {children}
                <div ref={lastElRef}></div>
            </div>
        </div>
    );
};

HorizontalScrollWithMask.propTypes = {
    children: PropTypes.node.isRequired,
};

export default HorizontalScrollWithMask;
